import { HttpErrorResponse } from '@angular/common/http';

/**
 * Pulls the server's explanation out of a failed roster update.
 *
 * The API returns business rejections — an active issue restriction, a failed validation rule —
 * as `{ success: false, message }` with a 400, and that message is written for the user. Anything
 * else (transport failure, unhandled 500) falls back to the caller's wording rather than leaking
 * framework or exception text into a toast.
 */
export function rosterActionErrorMessage(error: unknown, fallback: string): string {
  const message = (error as HttpErrorResponse | undefined)?.error?.message;
  return typeof message === 'string' && message.trim().length > 0 ? message : fallback;
}
